export const SUBSCRIPTION_UPDATED_EVENT = "assinafy:subscription-updated"

export const notifySubscriptionUpdated = (subscription) => {
  if (!subscription || typeof window === "undefined") return

  window.dispatchEvent(new CustomEvent(SUBSCRIPTION_UPDATED_EVENT, {
    detail: subscription,
  }))
}
